var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.167 7.477l-1.645-1.645L14 12.354 7.478 5.832 5.833 7.477l6.522 6.522-6.522 6.521 1.645 1.645L14 15.644l6.522 6.521 1.645-1.645L15.645 14l6.522-6.522z",
    fill: "#fff"
  })));
}
export default SvgBigClose;